import React from 'react';
import Minicard, { MiniCard as MiniCardProps } from './mini-card';
import Title, { Title as TitleProps } from './title';

export interface MiniCardContainerProps {
  miniCards: MiniCardProps[];
  titleInfo: TitleProps;
  titleRightClassName?: string;
}

const MiniCardContainer: React.FC<MiniCardContainerProps> = ({ miniCards, titleInfo, titleRightClassName }) => {
  const cards = () => {
    return miniCards?.map((miniCard, index) => {
      return (
        <div key={index} className="flex-1">
          <Minicard miniCard={miniCard} index={index} />
        </div>
      );
    });
  };

  return (
    <section data-testid="quick-action-card-group">
      <Title title={titleInfo} rightClassName={titleRightClassName}></Title>
      <div className="hidden items-stretch gap-10 lg:flex lg:flex-1" data-testid="quick-action-card-list">
        {cards()}
      </div>
    </section>
  );
};

export default MiniCardContainer;
